import React from "react"

import {trans} from '@utils'
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome"
import {TextIcon, MenuSoildIcon, EnvelopeIcon, PhoneIcon, HashIcon} from "@csrc/assets/icons"

export const CustomFieldTypes = {
  text: {label: 'customFields.singleLine', icon: <FontAwesomeIcon icon={TextIcon}/>, type: 'text'},
  textarea: {label: 'customFields.multiLine', icon: <FontAwesomeIcon icon={MenuSoildIcon}/>, type: 'textarea'},
  email: {label: 'customFields.email', icon: <FontAwesomeIcon icon={EnvelopeIcon}/>, type: 'email'},
  phone: {label: 'customFields.phone', icon: <FontAwesomeIcon icon={PhoneIcon}/>, type: 'phone'},
  integer: {label: 'customFields.number', icon: <FontAwesomeIcon icon={HashIcon}/>, type: 'integer'},
  decimal: {label: 'customFields.decimal', icon: <FontAwesomeIcon icon={HashIcon}/>, type: 'decimal'},
  lookup: {label: 'customFields.lookup', icon: <FontAwesomeIcon icon={HashIcon}/>, type: 'decimal', disabled: true}
}